import styled from 'styled-components';
import { MOBILE_WIDTH } from 'src/constants/style';

export const ContainerLayout = styled.div`
  padding: 20px 0 20px;
  display: flex;
  justify-content: center;

  @media all and (max-width: ${MOBILE_WIDTH}) {
    padding: 80px 0 20px;
  }
`;

export const ContentWrapper = styled.div`
  width: calc(100% - 260px);
  padding: 0 15px;

  @media all and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }
`;

export const SideMenuContainer = styled.div`
  .veneerMenu {
    height: auto !important;
    top: 80px;
  }

  ul {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  @media all and (max-width: ${MOBILE_WIDTH}) {
    .vn-side-menu__toggle {
      left: 15px;
      top: 0px;
      position: absolute;
    }

    .vn-side-menu__menu {
      top: 145px !important;
    }

    /*     .veneerMenu {
      height: 70px;
    } */
  }

  @media all and (min-width: ${MOBILE_WIDTH}) {
    width: 260px;

    div:last-child {
      height: 100%;
      top: 80px;
    }

    .vn-side-menu__logo,
    .vn-side-menu__menu {
      position: static !important;
    }

    .vn-side-menu__menu {
      height: 100%;
    }
  }
`;

export const MenuWrapperLoading = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 0;
`;
